import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { PrioritiesList } from '../interactions/PrioritiesList.jsx'
import { migratePrioritiesData } from '../interactions/prioritiesMigration.js'

/**
 * PrioritiesCard — three pre-defined ranked slots (rank 1 emphasised).
 * catalog #12, prep-priorities. Reuses PrioritiesList.
 * Phase E adds onMoveUp/onMoveDown wiring to PriorityRow.
 *
 * Note: PrioritiesList has its own row drag/reorder. The PriorityRow
 * keyboard reorder is at the primitive level for future use by other cards.
 */
export function PrioritiesCard({ card, value, onChange, disabled, activeGoals = [] }) {
  const migrated = migratePrioritiesData(value)
  const items = migrated?.items ?? []
  const hasFill = items.some((i) => i.text)

  return (
    <CardFrame
      kind="prep"
      icon="◼"
      iconClass="clay"
      title="Priorities"
      prompt="What are your top three priorities?"
      state={disabled ? 'locked' : hasFill ? 'filled' : 'empty'}
      data-testid="prep-card-prep-priorities"
      className="prepcard"
    >
      <PrioritiesList
        value={migrated}
        onChange={onChange}
        maxItems={3}
        activeGoals={activeGoals}
        disabled={disabled}
      />
    </CardFrame>
  )
}
